import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import * as Sentry from '@sentry/react';

export const reportToSentry = (e: unknown, context?): string => {
  return Sentry.captureException(e, context);
};

export const initSentry = (): void => {
  if (Sentry?.getCurrentScope()?.getClient()) {
    return;
  }

  Sentry.init({
    dsn: `${process.env.SENTRY_DSN}`,
    release: `${process.env.SENTRY_RELEASE}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    beforeSend: (event) => {
      if (
        process.env.VITE_APP_BUILD_ENV &&
        process.env.VITE_APP_BUILD_ENV === 'local'
      ) {
        console.error(event);
        return null; // this drops the event and nothing will be send to sentry
      }
      return event;
    },
    tracePropagationTargets: [
      /^\//,
      /(?:https:\/\/actual-atlas-(dev|prod)\.groupeactual\.eu\/dist\/js.*\.js)/g,
    ],
    environment: process.env.VITE_APP_BUILD_ENV ?? 'local',
    attachStacktrace: true,
  });
};
